const fallbackPostalCode = '0000';

/**
 * Accepts a string or number and
 * attempts to properly format it as postal code.
 * Should the number be invalid, will it default to 0000,
 * and log out a warning.
 *
 * @param {string|number} postalCode The postal-code to format
 * @return {string} a formatted postal-code
 * */
// eslint-disable-next-line import/prefer-default-export
export function formatPostalCode(postalCode) {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(postalCode)) {
    console.warn(`Invalid postal-code: ${postalCode}`);
    return fallbackPostalCode;
  }

  const codeAsNum = parseInt(postalCode, 10);

  if (postalCode.toString().length > 4) {
    console.warn(`Postal-code is too large: ${codeAsNum}`);
    return fallbackPostalCode;
  }

  return postalCode.toString().padStart(4, '0');
}

/**
 * Strips any chars which are not alphanumeric,
 * including whitespace.
 * @param {string} phrase Phrase to strip
 * @return {string} Stripped down version of the phrase
 * */
export function stripSpecialChars(phrase) {
  return phrase.replace(/[^A-Za-z0-9ÆØÅæøå]/g, '').split(' ').join('');
}

/**
 * Guarantees that the string will be no longer than maxLength characters,
 * suffix included.
 *
 * @param {string} phrase
 * @param {number} maxLength
 * @param {string} suffix
 * */
export function truncate(phrase, maxLength = 100, suffix = '...') {
  const highestLength = maxLength + suffix.length;

  if (!phrase || phrase.length <= highestLength) {
    return phrase;
  }

  const subPhrase = phrase.substring(0, maxLength);

  return `${subPhrase}${suffix}`;
}
